var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-page"},[_c('NotFoundComponent',{attrs:{"title":_vm.title,"message":_vm.message,"actionFunction":_vm.actionFunction,"actionLabel":_vm.actionLabel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }